/**
 * Define a hierarquia de roles no sistema
 * SuperAdmin > AdminEad > (SuperUser e Instructor e AdminClient) > Student
 */

export const ROLE_HIERARCHY = {
  SUPER_ADMIN: 5,
  ADMIN_EAD: 4,
  SUPER_USER: 3,
  ADMIN_CLIENT: 3,
  INSTRUCTOR: 2,
  STUDENT: 1,
};

/**
 * Retorna os roles que um usuário pode atribuir
 * O usuário pode ver e atribuir apenas roles com nível menor ou igual ao seu
 *
 * @param {string} currentUserRole - O role do usuário logado
 * @returns {string[]} - Array de roles que podem ser atribuídos
 */
export const getAssignableRoles = currentUserRole => {
  const allRoles = ['STUDENT', 'INSTRUCTOR', 'ADMIN_CLIENT', 'ADMIN_EAD', 'SUPER_ADMIN'];

  // Filtra roles que podem ser atribuídos
  return allRoles.filter(role => {
    // SuperAdmin pode ver todos
    if (currentUserRole === 'SUPER_ADMIN') {
      return true;
    }

    // AdminEad não pode ver SuperAdmin
    if (currentUserRole === 'ADMIN_EAD' && role === 'SUPER_ADMIN') {
      return false;
    }

    // AdminClient não pode ver AdminEad, SuperUser, Instrutor e SuperAdmin
    if (currentUserRole === 'ADMIN_CLIENT') {
      return !['SUPER_ADMIN', 'ADMIN_EAD', 'SUPER_USER', 'INSTRUCTOR'].includes(role);
    }

    // Outros roles só veem Student
    if (!['SUPER_ADMIN', 'ADMIN_EAD', 'ADMIN_CLIENT'].includes(currentUserRole)) {
      return role === 'STUDENT';
    }

    return true;
  });
};

/**
 * Retorna os usuários que podem ser vistos pelo usuário logado
 * Filtra a lista de usuários com base na hierarquia
 *
 * @param {Array} users - Array de usuários
 * @param {string} currentUserRole - O role do usuário logado
 * @returns {Array} - Array de usuários filtrados
 */
export const filterVisibleUsers = (users, currentUserRole) => {
  // SuperAdmin pode ver todos
  if (currentUserRole === 'SUPER_ADMIN') {
    return users;
  }

  // AdminEad não pode ver SuperAdmin
  if (currentUserRole === 'ADMIN_EAD') {
    return users.filter(user => user.role !== 'SUPER_ADMIN');
  }

  // AdminClient não pode ver AdminEad, SuperUser, Instrutor e SuperAdmin
  if (currentUserRole === 'ADMIN_CLIENT') {
    return users.filter(
      user => !['SUPER_ADMIN', 'ADMIN_EAD', 'SUPER_USER', 'INSTRUCTOR'].includes(user.role)
    );
  }

  // Outros roles só veem Student
  return users.filter(user => user.role === 'STUDENT');
};
